export default "__VITE_ASSET__bCuQvJ$D__"